import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Input, useAuthContext } from '../../core/components'
import { routesConfig } from '../../core/configs/routes'
import { login } from '../../services/Auth'

export const LoginForm = () => {
  const history = useHistory()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const { setUser } = useAuthContext()

  const handleOnFinish = async () => {
    const user: any = await login({
      username,
      password
    })

    if (user?.data) {
      setUser(user.data)
      history.push(routesConfig.home)
    }
  }

  return (
    <>
      <h4>USUÁRIO:</h4>
      <Input
        prefix={<UserOutlined />}
        value={username}
        onChange={(e) => setUsername(e.target.value.toUpperCase())}
        onPressEnter={handleOnFinish}
      />
      <h4>SENHA:</h4>
      <Input
        prefix={<LockOutlined />}
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onPressEnter={handleOnFinish}
      />
      <Button
        size="large"
        type="primary"
        htmlType="submit"
        block
        onClick={handleOnFinish}
      >
        Entrar
      </Button>
    </>
  )
}
